/**
 * Providers and hosts that sit around the whole shell because both the chrome
 * and the page use them (prototype: the context stack in App.tsx).
 */
import { lazy, Suspense, type ReactNode } from 'react';

import { ConversationsProvider } from '@/features/conversations';
import { useDataSource } from '@/features/data/DataSourceContext';

const InviteMemberHost = lazy(() =>
  import('@/features/settings/InviteMemberHost').then((module) => ({
    default: module.InviteMemberHost,
  })),
);

/** The invite dialog and its Settings data never enter the live initial path. */
function MockInviteMemberHost() {
  const { source } = useDataSource();
  if (source !== 'mock') return null;
  return (
    <Suspense fallback={null}>
      <InviteMemberHost />
    </Suspense>
  );
}

export function ShellProviders({ children }: { children: ReactNode }) {
  return (
    <ConversationsProvider>
      {children}
      <MockInviteMemberHost />
    </ConversationsProvider>
  );
}
